"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectConfigStoreDataProvider = exports.useProjectConfigStoreDataContext = exports.getConfigurationValueText = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const typescriptAddons_1 = require("src/configeek_assets/src/system/typescriptAddons");
const ActorsProvider_1 = require("src/configeek_assets/src/components/common/provider/ActorsProvider");
const Commons_1 = require("src/configeek_assets/src/components/common/provider/Commons");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const getConfigurationValueText = (configurationValue) => {
    if (configurationValue.type === "string") {
        return configurationValue.value;
    }
};
exports.getConfigurationValueText = getConfigurationValueText;
const initialContextValue = {
    config: (0, Commons_1.getDefaultCGFeature)(),
};
const ProjectConfigStoreDataContext = React.createContext(undefined);
const useProjectConfigStoreDataContext = () => {
    const context = React.useContext(ProjectConfigStoreDataContext);
    if (!context) {
        throw new Error("useProjectConfigStoreDataContext must be used within a ProjectConfigStoreDataContext.Provider");
    }
    return context;
};
exports.useProjectConfigStoreDataContext = useProjectConfigStoreDataContext;
const ProjectConfigStoreDataProvider = (props) => {
    var _a;
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const fetchAuditLog = (0, react_1.useCallback)(async (auditRequest) => {
        try {
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const issueAuditAccessTokenResult = await managementActor.issueAuditAccessToken(props.projectApiKey);
                if (!!process.env.IS_TEST_SERVER) {
                    console.log(`issueAuditAccessTokenResult:`, issueAuditAccessTokenResult);
                }
                if ((0, ICCanisterUtils_1.isOk)(issueAuditAccessTokenResult)) {
                    const auditAccessToken = issueAuditAccessTokenResult.ok;
                    const configStoreActor = await actorsContext.getConfigStoreActor(props.configStoreCanisterId);
                    if (configStoreActor) {
                        if (process.env.NODE_ENV === "development") {
                            // await delayPromise(1000)
                            // if (Math.random() > 0.5) {
                            //     throw "AAA"
                            // }
                        }
                        const result = await configStoreActor.getAudit(auditAccessToken, auditRequest);
                        // if (!!process.env.IS_TEST_SERVER) {
                        //     console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].fetchAuditLog: configStoreActor.getConfigFull result`, result);
                        // }
                        if ((0, ICCanisterUtils_1.isOk)(result)) {
                            const auditRequestResult = result.ok;
                            const auditLogRecords = lodash_1.default.map(auditRequestResult.records, icRecord => {
                                return mapICAuditRecordToView(icRecord);
                            });
                            return {
                                status: "success", result: {
                                    records: auditLogRecords,
                                    haveMore: auditRequestResult.haveMore
                                }
                            };
                        }
                        else if ((0, ICCanisterUtils_1.isErr)(result)) {
                            const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                            return { status: "error", reason: errorName };
                        }
                    }
                    else {
                        return { status: "unknownError", error: new Error("noConfigStoreActor") };
                    }
                }
            }
            else {
                return { status: "unknownError", error: new Error("noManagementActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [actorsContext.getConfigStoreActor, props.configStoreCanisterId, props.accessToken]);
    const [config, updateConfig] = (0, react_1.useReducer)(Commons_1.simpleFeatureReducer, initialContextValue.config);
    const fetchConfig = (0, react_1.useCallback)(async () => {
        updateConfig({ status: { inProgress: true } });
        try {
            const configStoreActor = await actorsContext.getConfigStoreActor(props.configStoreCanisterId);
            if (configStoreActor) {
                // console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].fetchConfig: configStoreActor`, configStoreActor);
                // if (process.env.NODE_ENV === "development") {
                // await delayPromise(1000)
                // if (Math.random() < 0.5) {
                //     throw new Error("Temp error!" + (+new Date))
                // }
                // }
                const result = await getConfigFullRecursively(configStoreActor, {
                    accessToken: props.accessToken,
                    accumulator: [],
                    continuation: undefined
                });
                // if (!!process.env.IS_TEST_SERVER) {
                //     console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].fetchConfig: result`, result);
                // }
                switch (result.status) {
                    case "success": {
                        const configKeys = result.result.data;
                        const keyValuePairs = lodash_1.default.compact(lodash_1.default.map(configKeys, tuple => {
                            const rawKey = tuple[0];
                            const rawValue = tuple[1];
                            if ((0, typescriptAddons_1.hasOwnProperty)(rawValue, "text")) {
                                const value = rawValue.text;
                                return {
                                    key: rawKey,
                                    value: value
                                };
                            }
                            return undefined;
                        }));
                        updateConfig({
                            status: { inProgress: false, loaded: true },
                            error: { error: undefined, isError: false },
                            data: {
                                configKeys: keyValuePairs
                            },
                            time: { updatedAt: DateTimeUtils_1.DateTimeUtils.now() }
                        });
                        return;
                    }
                    case "error": {
                        const reason = result.reason;
                        console.error(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].fetchConfig: got error`, reason);
                        updateConfig({
                            status: { inProgress: false, loaded: true },
                            error: { error: new Error(reason), isError: true },
                            data: undefined,
                        });
                        return;
                    }
                    case "unknownError": {
                        // noinspection ExceptionCaughtLocallyJS
                        throw result.error;
                    }
                }
            }
            else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("unknown");
            }
            // noinspection ExceptionCaughtLocallyJS
            throw new Error("unknown");
        }
        catch (e) {
            console.error(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].fetchConfig: caught error`, e);
            updateConfig({
                status: { inProgress: false, loaded: true },
                error: { error: e, isError: true },
                data: undefined,
            });
        }
    }, [actorsContext.getConfigStoreActor, props.configStoreCanisterId, props.accessToken]);
    const hasConfigKeys = (0, react_1.useCallback)(() => {
        var _a;
        return !lodash_1.default.isEmpty((_a = config.data) === null || _a === void 0 ? void 0 : _a.configKeys);
    }, [(_a = config.data) === null || _a === void 0 ? void 0 : _a.configKeys]);
    const putConfigKey = (0, react_1.useCallback)(async (key, value) => {
        try {
            // console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].putConfigKey: will put configKeyValuePair`, {key, value});
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const result = await managementActor.putProjectValue(props.projectApiKey, key, { text: value });
                // if (!!process.env.IS_TEST_SERVER) {
                //     console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].putConfigKey: result`, result);
                // }
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    return { status: "success", result: undefined };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const error = result.err;
                    if ((0, typescriptAddons_1.hasOwnProperty)(error, "validationError")) {
                        const validationError = error.validationError;
                        const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(validationError);
                        return { status: "error", reason: validationErrorName };
                    }
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [actorsContext.getManagementActor, props.projectApiKey]);
    const removeConfigKey = (0, react_1.useCallback)(async (key) => {
        try {
            // console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].removeConfigKey: will remove key`, key);
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                const result = await managementActor.removeProjectValue(props.projectApiKey, key);
                // if (!!process.env.IS_TEST_SERVER) {
                //     console.log(`ProjectConfigStoreDataProvider[${props.configStoreCanisterId}].removeConfigKey: result`, result);
                // }
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    return { status: "success", result: undefined };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [actorsContext.getManagementActor, props.projectApiKey]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        config,
        fetchConfig,
        hasConfigKeys,
        putConfigKey,
        removeConfigKey,
        fetchAuditLog,
    }), [
        config,
        fetchConfig,
        hasConfigKeys,
        putConfigKey,
        removeConfigKey,
        fetchAuditLog,
    ], lodash_1.default.isEqual);
    return React.createElement(ProjectConfigStoreDataContext.Provider, { value: value }, props.children);
};
exports.ProjectConfigStoreDataProvider = ProjectConfigStoreDataProvider;
const mapICAuditRecordToView = (icRecord) => {
    // console.log("mapICAuditRecordToView: icRecord", icRecord);
    const [icRecordUpdateId, icRecordParameterName, icRecordAction, icRecordConfigValueNew, icRecordConfigValueOld, icRecordPrincipal, icRecordTimeSeconds] = icRecord;
    const parameterValueNew = mapICAuditRecordValueToViewValue(icRecordConfigValueNew);
    const parameterValueOld = mapICAuditRecordValueToViewValue(icRecordConfigValueOld);
    const action = mapICAuditRecordActionToViewAction(icRecordAction);
    const timeMillis = icRecordTimeSeconds * 1000;
    return {
        updateId: icRecordUpdateId,
        principal: icRecordPrincipal.toText(),
        parameterName: icRecordParameterName,
        parameterValueNew: parameterValueNew,
        parameterValueOld: parameterValueOld,
        action: action,
        originalTimeSeconds: icRecordTimeSeconds,
        timeMillis: timeMillis,
    };
};
const mapICAuditRecordValueToViewValue = (icRecordConfigValue) => {
    let icParameterValue = undefined;
    if (icRecordConfigValue.length === 1) {
        icParameterValue = icRecordConfigValue[0];
    }
    if (icParameterValue != undefined) {
        const icConfigValueType = (0, ICCanisterUtils_1.getICFirstKey)(icParameterValue);
        switch (icConfigValueType) {
            case "text":
                return { type: "string", value: icParameterValue[icConfigValueType] };
            default: {
                //skip - will use {type: "none"} by default
                break;
            }
        }
    }
    return { type: "none" };
};
const mapICAuditRecordActionToViewAction = (icRecordAction) => {
    const icConfigValueAction = (0, ICCanisterUtils_1.getICFirstKey)(icRecordAction);
    switch (icConfigValueAction) {
        case "new":
            return "new";
        case "modify":
            return "modify";
        case "remove":
            return "remove";
        default: {
        }
    }
    return "unknown";
};
const getConfigFullRecursively = async (configStoreActor, context) => {
    // if (!!process.env.IS_TEST_SERVER) {
    //     console.log("getConfigFullRecursively: start with", context);
    // }
    if (context.continuation) {
        const result = await configStoreActor.getConfigFullContinuation(context.accessToken, context.continuation);
        // if (!!process.env.IS_TEST_SERVER) {
        //     console.log("getConfigFullRecursively: getConfigFullContinuation result", result);
        // }
        if ((0, ICCanisterUtils_1.isOk)(result)) {
            return await processFullPartial(configStoreActor, context, result.ok);
        }
        else if ((0, ICCanisterUtils_1.isErr)(result)) {
            const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(result.err);
            return {
                status: "error", reason: validationErrorName
            };
        }
    }
    else {
        const result = await configStoreActor.getConfigFull(context.accessToken);
        // if (!!process.env.IS_TEST_SERVER) {
        //     console.log("getConfigFullRecursively: getConfigFull result", result);
        // }
        if ((0, ICCanisterUtils_1.isOk)(result)) {
            const fullVariant = result.ok;
            if ((0, typescriptAddons_1.hasOwnProperty)(fullVariant, "full")) {
                const newAccumulator = [
                    ...context.accumulator,
                    ...fullVariant.full
                ];
                return {
                    status: "success",
                    result: {
                        data: newAccumulator
                    }
                };
            }
            else if ((0, typescriptAddons_1.hasOwnProperty)(fullVariant, "fullPartial")) {
                return await processFullPartial(configStoreActor, context, fullVariant.fullPartial);
            }
        }
        else if ((0, ICCanisterUtils_1.isErr)(result)) {
            const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(result.err);
            return {
                status: "error", reason: validationErrorName
            };
        }
    }
    return {
        status: "unknownError", error: new Error("unknown")
    };
};
const processFullPartial = async (configStoreActor, context, fullPartial) => {
    const continuation = (0, ICCanisterUtils_1.getICOptional)(fullPartial.continuation);
    // console.log("processFullPartial: continuation", continuation);
    const newAccumulator = [
        ...context.accumulator,
        ...fullPartial.data
    ];
    if (continuation) {
        return await getConfigFullRecursively(configStoreActor, {
            ...context,
            continuation: continuation,
            accumulator: newAccumulator
        });
    }
    else {
        return {
            status: "success",
            result: {
                data: newAccumulator
            }
        };
    }
};
